import {
  CREATE_CONNECT_ACCOUNT,
  CREATE_CONNECT_ACCOUNT_FAILED,
  CREATE_CONNECT_ACCOUNT_SUCCESS,
  GENERATE_CONNECT_LINK,
  GENERATE_CONNECT_LINK_FAILED,
  GENERATE_CONNECT_LINK_SUCCESS,
  GET_BALANCE,
  GET_BALANCE_FAILED,
  GET_BALANCE_SUCCESS,
  GET_EXPRESS_LINK,
  GET_EXPRESS_LINK_FAILED,
  GET_EXPRESS_LINK_SUCCESS,
  REDEEM_BALANCE,
  REDEEM_BALANCE_FAILED,
  REDEEM_BALANCE_SUCCESS,
  REFUND_BALANCE,
  REFUND_BALANCE_FAILED,
  REFUND_BALANCE_SUCCESS,
  SEND_INVOICE,
  SEND_INVOICE_FAILED,
  SEND_INVOICE_SUCCESS,
} from './constants';

const getBalance = (userId) => ({
  type: GET_BALANCE,
  payload: { userId },
});

const getBalanceSuccess = ({ available, pending, loginLink, isValid }) => ({
  type: GET_BALANCE_SUCCESS,
  payload: { available, pending, loginLink, isValid },
});

const getBalanceFailed = (error) => ({
  type: GET_BALANCE_FAILED,
  payload: { error },
});

const createConnectAccount = (userId) => ({
  type: CREATE_CONNECT_ACCOUNT,
  payload: { userId },
});

const createConnectAccountSuccess = () => ({
  type: CREATE_CONNECT_ACCOUNT_SUCCESS,
});

const createConnectAccountFailed = (error) => ({
  type: CREATE_CONNECT_ACCOUNT_FAILED,
  payload: { error },
});

const generateConnectAccountLink = (userId) => ({
  type: GENERATE_CONNECT_LINK,
  payload: { userId },
});

const generateConnectAccountLinkSuccess = () => ({
  type: GENERATE_CONNECT_LINK_SUCCESS,
});

const generateConnectAccountLinkFailed = (error) => ({
  type: GENERATE_CONNECT_LINK_FAILED,
  payload: { error },
});

const getExpressLink = (userId, isAdmin) => ({
  type: GET_EXPRESS_LINK,
  payload: { userId, isAdmin },
});

const getExpressLinkSuccess = (expressLink) => ({
  type: GET_EXPRESS_LINK_SUCCESS,
  payload: { expressLink },
});

const getExpressLinkFailed = (error) => ({
  type: GET_EXPRESS_LINK_FAILED,
  payload: { error },
});

const redeemBalance = (userId, amount) => ({
  type: REDEEM_BALANCE,
  payload: { userId, amount },
});

const redeemBalanceSuccess = (amount) => ({
  type: REDEEM_BALANCE_SUCCESS,
  payload: { amount },
});

const redeemBalanceFailed = (error) => ({
  type: REDEEM_BALANCE_FAILED,
  payload: { error },
});

const refundBalance = (transactionId, amount, venueId) => ({
  type: REFUND_BALANCE,
  payload: { transactionId, amount, venueId },
});

const refundBalanceSuccess = () => ({
  type: REFUND_BALANCE_SUCCESS,
});

const refundBalanceFailed = (error) => ({
  type: REFUND_BALANCE_FAILED,
  payload: { error },
});

const sendInvoice = (eventId, vendorId) => ({
  type: SEND_INVOICE,
  payload: { eventId, vendorId },
});

const sendInvoiceSuccess = () => ({
  type: SEND_INVOICE_SUCCESS,
});

const sendInvoiceFailed = (error) => ({
  type: SEND_INVOICE_FAILED,
  payload: { error },
});

export {
  getBalance,
  getBalanceSuccess,
  getBalanceFailed,
  createConnectAccount,
  createConnectAccountSuccess,
  createConnectAccountFailed,
  generateConnectAccountLink,
  generateConnectAccountLinkSuccess,
  generateConnectAccountLinkFailed,
  redeemBalance,
  redeemBalanceSuccess,
  redeemBalanceFailed,
  getExpressLink,
  getExpressLinkSuccess,
  getExpressLinkFailed,
  refundBalance,
  refundBalanceSuccess,
  refundBalanceFailed,
  sendInvoice,
  sendInvoiceSuccess,
  sendInvoiceFailed,
};
